import { axiosInstanceV2 } from "@src/shared/api";
import {
  ApplyPromoCodeRequest,
  ApplyPromoCodeResponse,
} from "../interfaces/applyPromoCode";
import { PAYMENTS_API_URL } from "../constants";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

export const applyPromoCode = async (
  params: ApplyPromoCodeRequest,
): Promise<ApplyPromoCodeResponse> => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;

  const { data } = await axiosInstanceV2.post<ApplyPromoCodeResponse>(
    PAYMENTS_API_URL.applyPromoCode(),
    params,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );

  return data;
};
